<template>
    <!--<nav-menu></nav-menu>-->
    <router-view class="view" v-slot="{ Component }" :key="$route.path">
        <transition name="slide-fade" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view>
</template>

<script>
    //import NavMenu from './components/NavMenu.vue'

    export default {
        name: 'App',
        components: {
            //NavMenu
        }
    }
</script>

<style>
      #app {
          /*-webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;*/
      }

      .slide-fade-enter-active {
          transition: all 0.5s ease;
      }

      .slide-fade-leave-active {
          transition: all 1s cubic-bezier(1, 0.5, 0.8, 1);
      }

      .slide-fade-enter, .slide-fade-leave-to {
          transform: translateX(30px);
          opacity: 0;
      }
</style>
